<template>
  <div>
    <div class="page-header page-header-small">
      <parallax
        class="page-header-image"
        style="background-image: url('img/transplus_transportation.jpg')"
      />
      <div class="content-center">
        <div class="container">
          <h1
            class="title"
            v-html="$t('General.Transportation')"
          >
            Transportation<span class="tpgreen">.</span class="tpgreen"></span>
          </h1>
        </div>
      </div>
    </div>

    <div class="section">
      <div class="container">
        <div class="row">
          <div class="col-md-8 fuel-wrap ml-auto mr-auto"> 
            <div
              class="fuel-button"
              onclick="window.open('https://docs.google.com/spreadsheets/d/e/2PACX-1vTaCF3q0tkxSYEZSIR2wdhkbpk46QbG63Qq5IF43z8GzQ0_HL1powuP0AfH0F7MzDxkyK4ZVNXU2zSh/pubhtml', '_blank')"
            >
              <i class="far fa-gas-pump fa-3x" />
              <div
                class="text"
                v-html="$t('Transportion.fsc')"
              >
                FUEL SURCHARGE
              </div>
            </div>
          </div>      
        </div>
        <div class="row">          
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2
              class="title"
              v-html="$t('Transportion.Transportationdesc1')"
            >
              Our path to success is rooted in <span class="tpgreen">reliability</span> and <span class="tpgreen">connectivity.</span>
            </h2>
            <h5
              class="description"
              v-html="$t('Transportion.Transportationdesc2')"
            >
              We cover from regional to national grounds and service to a wide range of industries that produce consumer goods, food-grade products, raw materials, and industrial products. Our individualized solutions help build a reliable and predictable network for your business.
            </h5>
          </div>         
        </div>
      </div>
    </div>
 
    <hr class="tpgreen">
    <!-- -->
    <div class="section">
      <div class="container col-md-10">
        <div
          class="row"
          style="margin-bottom: 40px;"
        >
          <div class="col-md-3 ml-auto mr-auto gap">            
            <!--<img slot="image" class="card-img-top" :src="imgTrans" alt="Card image cap">-->
            <div style="color:dodgerblue">
              <i class="far fa-analytics fa-6x" />
            </div>
            <div>
              <h4
                class="card-title"
                v-html="$t('Transportion.TMS')"
              >
                TMS - Transportation Management System
              </h4>
              <p
                class="card-text"
                style="font-size:14px"
                v-html="$t('Transportion.TMSdesc')"
              >
                TMS boosts effective comprehension for operations, dispatch, and accounting. From real-time information management to optimized delivery routes, TMS allows you to filter by zone, terminal, driver manager, inbound or outbound deliveries, and more. Both our TMS and WMS are interactively linked for greater efficiency. 
              </p>
            </div>            
          </div>
          <div class="col-md-3 ml-auto mr-auto gap">            
            <!--<img slot="image" class="card-img-top" :src="imgWare" alt="Card image cap">-->
            <div style="color:dodgerblue">
              <i class="far fa-key fa-6x" />
            </div>
            <div>
              <h4
                class="card-title"
                v-html="$t('Transportion.PrivateFleet')"
              >
                Private Fleet
              </h4>
              <p
                class="card-text"
                style="font-size:14px"
                v-html="$t('Transportion.PrivateFleetdesc')"
              >
                Our fleet, which consists of over 400 company owned units, undergoes rigorous maintenance and runs on eco-friendly fuels. We carefully select, train, and manage our drivers to ensure punctual and quality customer centred service. 
              </p>
            </div>            
          </div>
          <!--
        </div>        
        <div class="row">
        -->
          <div class="col-md-3 ml-auto mr-auto gap">          
            <!--<img slot="image" class="card-img-top" :src="imgFreight" alt="Card image cap">-->
            <div style="color:dodgerblue">
              <i class="far fa-satellite-dish fa-6x" />
            </div>
            <div>
              <h4
                class="card-title"
                v-html="$t('Transportion.GPS')"
              >
                GPS Protected
              </h4>
              <p
                class="card-text "
                style="font-size:14px"
                v-html="$t('Transportion.GPSdesc')"
              >
                Our dedicated team closely tracks our fleet location at all times. With greater visibility, we can respond quickly in the events of delays. This allows us to get your products to their final destination faster and in their desired condition.
              </p>              
            </div>            
          </div>
          <div class="col-md-3 ml-auto mr-auto gap">          
            <!--<img slot="image" class="card-img-top" :src="imgFreight" alt="Card image cap">-->
            <div style="color:dodgerblue">
              <i class="far fa-tasks fa-6x" />
            </div>
            <div>
              <h4
                class="card-title"
                v-html="$t('Transportion.YMS')"
              >
                YMS - Yard Management System
              </h4>
              <p
                class="card-text"
                style="font-size:14px"
                v-html="$t('Transportion.YMSdesc')"
              >
                Achieving the right balance of inbound and outbound freight relies on effective yard management. Real-time yard counts and asset activities enable accurate visibility. For seamless operations management, our YMS is integrated with our WMS and TMS.
              </p>
            </div>            
          </div>
        </div>
      </div>
    </div>  
    <!-- -->
    <div class="bluesection">       
      <h2
        class="title"
        v-html="$t('Transportion.private')"
      >
        We privately own over 400 units that operate in Eastern Canada.
      </h2>
    </div>


    <!-- newsection JOE  -->
    <div
      class="section"
      style="border: 0px solid green;"
    >
      <h2 class="title text-center">
        01<span class="tpgreen">.</span><br>
        <span style="font-size: .75em;" v-html="$t('Transportion.OvertheRoad')">
          Over the Road<span class="tpgreen">.</span>
        </span>
      </h2>

      <div class="container elgrey">                
        <div class="row">                  
          <div class="lr elmaster">
            <span
              class="left"
              style="font-size: 1.5em;font-weight:bold;"
              v-html="$t('Transportion.DediTransport')"
            >Dedicated Transportation</span>
            <span
              class="right light"
              v-html="$t('Transportion.DediTransportdesc')"
            >Consistency is key when it comes to building a cost-effective system designed for you. By providing specialized equipment and keeping to specific schedules and routes, you are guaranteed on-time deliveries. We understand that demand and needs can fluctuate, and therefore we are quick to adapt.</span>
          </div>

          <div class="lr elmaster">
            <span
              class="left"
              style="font-size: 1.5em;font-weight:bold"
              v-html="$t('Transportion.RefTrailers')"
            >Refrigerated Trailers</span>
            <span
              class="right light"
              v-html="$t('Transportion.RefTrailersdesc')"
            >Our state-of-the-art, temperature-controlled reefers monitor the exact temperature for fresh and frozen goods.</span>
          </div>

          <div class="lr elmaster">
            <span
              class="left"
              style="font-size: 1.5em;font-weight:bold"
              v-html="$t('Transportion.FTL')"
            >FTL - Full Truckload</span>
            <span
              class="right light"
              v-html="$t('Transportion.FTLdesc')"
            >For large shipments, benefit from the perks of our economic point-to-point FTL pick-up and delivery service. Both short and long-haul trips are available options  to you.</span>
          </div>
          
          <div class="lr elmaster">
            <span
              class="left"
              style="font-size: 1.5em;font-weight:bold"
              v-html="$t('Transportion.LTL')"
            >LTL - Less Than Truckload</span>
            <span
              class="right light"
              v-html="$t('Transportion.LTLdesc')"
            >For a smaller freight, take advantage of our multi-stop LTL trucking routes that are planned for both local or long-haul trips.</span>              
          </div>   

          <div class="lr elmaster">
            <span
              class="left"
              style="font-size: 1.5em;font-weight:bold"
              v-html="$t('Transportion.SpecFreight')"
            >Specialized Freights</span>
            <span
              class="right light"
              v-html="$t('Transportion.SpecFreightdesc')"
            >Secure handling of oversized or overweight freights is key. If you require flatbed transportation, our experienced drivers will move your inventory safely to anywhere in Canada and the U.S.</span>              
          </div>
        </div>
      </div>
    </div>
    <!--- end section joe -->

    <hr class="tpgreen">

    <!-- newsection JOE  -->
    <div
      class="section"
      style="border: 0px solid green;"
    >
      <h2 class="title text-center">
        02<span class="tpgreen">.</span><br>
        <span style="font-size: .75em;" v-html="$t('Transportion.ContainerTypes')">
          Container Types<span class="tpgreen">.</span>
        </span>
      </h2>

      <div class="container elgrey">                
        <div class="row">                  
          <div class="lr elmaster">
            <span
              class="left"
              style="font-size: 1.5em;font-weight:bold;"
              v-html="$t('Transportion.Global')"
            >Global</span>
            <span
              class="right light"
              v-html="$t('Transportion.Globaldesc')"
            >Our proximity to major highways, international airports, local water ports, and railways facilitates seamless transport. Whether you need to import or export dry goods or temperature-controlled shipments, we can manage your freight transportation at an international level.</span>
          </div>

          <div class="lr elmaster">
            <span
              class="left"
              style="font-size: 1.5em;font-weight:bold"
              v-html="$t('Transportion.Intermodal')"
            >Intermodal</span>
            <span
              class="right light"
              v-html="$t('Transportion.Intermodaldesc')"
            >Through our strong partnerships, we successfully combine multiple modes of transportation so your goods make it to their final destination intact and on time. Whether transported by water, air, or land, we provide you with flexible solutions.</span>
          </div>

          <div class="lr elmaster">
            <span
              class="left"
              style="font-size: 1.5em;font-weight:bold"
              v-html="$t('Transportion.Drayage')"
            >Drayage</span>
            <span
              class="right light"
              v-html="$t('Transportion.Drayagedesc')"
            >Our trucking fleet is equipped to move your intermodal containers to and from Canadian ports and rail terminals.</span>
          </div>
        </div>
      </div>
    </div>
    <!--- end section joe -->

    <!-- -->
    <!--<div class="section gotoservices" >-->
    <div class="col-md-8 ml-auto mr-auto text-center">
      <!-- <a href="/quote" v-html="$t('General.getquotebusiness')">Get a quote for your business  <span class="tpgreen">→</span></a> -->
      <a
        class="nav-link requestaquote"
        href="/quote"
        style="color:white; text-transform: capitalize;"
      >{{ $t("navbar.quote") }}</a>
    </div>
  </div>
</template>
<script scoped>

import {Collapse, CollapseItem} from '@/components';

export default {
  components: {
    Collapse,
    CollapseItem
  },
  data() {
    return {
      imgWare: "img/bg1.jpg",
      imgTrans: "img/bg4.jpg",
      imgFreight: "img/bg3.jpg",
    }
  }
};
</script>
<style scoped>
.fuel-wrap {  
  padding: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 180px;
}
.fuel-button {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-weight: bold;
    font-size: 14px;
    background-color: white;
    color: #333333;
    min-width: 144px;
    height: 96px;
    cursor: pointer;
    transition: height 0.3s ease, background-color 0.3s ease, color 0.3s ease, border 0.3s ease;
    padding: 12px;
    border-left: 1px solid #EAEAEA;
    border-top: 1px solid #EAEAEA;
    border-right: 1px solid #EAEAEA;
    border-bottom: 1px solid #EAEAEA;
    text-align: center;
    user-select: none;
}

.fuel-button:hover {
    background-color: #1E90FF;
    color: white;
    height: 128px;
    border: none;
}

.fuel-button i {
    font-size: 1.5rem;
}

.fuel-button .text {
    font-size: 14px;
    letter-spacing: 0.5px;
    line-height: 1.2;
}
.highlight{
  color:white
}
.highlight:hover{
  color:white
}
.blue{
  color:white;
  background-color: dodgerblue;
  text-align:center;
  padding: 20px;
}
.gap {
  margin:20px
}
@media only screen and (min-width:768px) {
  .card-title{
    /*background-color: #eee;*/
    /*height: 50px;*/
  }
}

@media only screen  and (min-width:768px) and (max-width:1280px) {  
  .card-title{
    /*background-color: #eee;*/
  }
}

@media only screen and (max-width: 600px) { 
  .page-header-small{
            min-height: 40vh;
            max-height: 440px;
    }
  .title{
    font-size:2.75em;
  }
}
</style>
